// extracted by mini-css-extract-plugin
export default {"contain":"Footer_contain__PPkSp","content":"Footer_content__W2NLX","logop":"Footer_logop__d7oUC","escrita":"Footer_escrita__OaWKS","buttoncontact":"Footer_buttoncontact__VwC6f"};